import { createAsyncThunk } from '@reduxjs/toolkit'
import { benefitsData } from '@assets/mockdata'
import { Benefit, UpdateBenefitThunkParams } from '@dataTypes/index'

export const fetchAllBenefits = createAsyncThunk(
  'benefits/fetchAllBenefits',
  async () => {
    return benefitsData
  },
)

export const addBenefit = createAsyncThunk(
  'benefits/addBenefit',
  async (body: Benefit) => {
    return body
  },
)

export const updateBenefit = createAsyncThunk(
  'benefits/updateBenefit',
  async (params: UpdateBenefitThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeBenefit = createAsyncThunk(
  'benefits/removeBenefit',
  async (index: string) => {
    return index
  },
)
